import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AspClutchKitDetailsComponent } from './asp-clutch-kit-details.component';
import { RouterModule, Routes } from '@angular/router';
import { MatButtonModule }   from '@angular/material/button';
import { MatIconModule }     from '@angular/material/icon';
import { MatCardModule }     from '@angular/material/card';
import { MatListModule }     from '@angular/material/list';
import { MatDividerModule }  from '@angular/material/divider';
import { MatDialogModule }   from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ApplicationPipesModule } from 'app/main/applicationPipesModule.module';
import { MatTabsModule } from '@angular/material/tabs';

const routes: Routes = [
  {
      path: 'kit-details/:type/:id',
      component: AspClutchKitDetailsComponent,
  },
];

@NgModule({
  declarations: [AspClutchKitDetailsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes) ,
    BrowserModule,
    FormsModule,
    CommonModule,
    MatIconModule,
    MatExpansionModule,
    MatCheckboxModule,
    BrowserAnimationsModule,
    MatProgressBarModule,
    ApplicationPipesModule,
    MatTabsModule
  ],
   exports: [AspClutchKitDetailsComponent],
})
export class AspClutchKitDetailsModule { }
